import { Button, Grid, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import React, { useRef, useState } from "react";
import { connect } from "react-redux";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { } from "../../store/actions";
import ExportSample from "./ExportSequencing";
// import ExportSampleList from "./ExportSamples";
// import { getLogisticStopsData } from "../../actions/LogisticsPanelAction";
// import { generateStopsFilter } from "../../../helpers/generateUrl";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem 2rem 2rem",
      width: "100%",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
      minHeight: "64px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    card: {
      height: "100%",
      padding: "20px",
    },
    cardContent: {
      textAlign: "center",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    text: { color: "black" },
  })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
interface Props {
  getCities: any;
  cities: any;
  postStops: any;
  updateStops: any;
  getStops: any;
  stopsData: any;
  getLogisticStopsData: any,
  logisticstopsdata: any,
  getBookingOverview: any;
  bookingoverview: any;
  phleboList: any;
  centerInfo: any;
  rateListExport: any;
  getDisplayCities: any;
  loading: any;
}
const StopsPlace: React.FC<Props> = ({
  getCities,
  getLogisticStopsData,
  logisticstopsdata,
  cities,
  postStops,
  updateStops,
  getStops,
  stopsData,
  getBookingOverview,
  bookingoverview,
  getDisplayCities,
  rateListExport,
  loading

}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  const [lab, setLab] = React.useState<any>("");
  const [project, setProject] = React.useState<any>("");
  const [latitude, setLatitude] = React.useState<any>("");
  const [subProject, setSubProject] = useState<any>("");
  const [city, setCity] = useState<any>("");
  const [citys, setCitys] = useState<any>("");
  const [cityName, setCityName] = useState<any>("");
  const [cityNames, setCityNames] = useState<any>("")
  const [isEdit, setIsEdit] = useState<any>(false);
  const [editId, setEditId] = useState<any>("");
  const [page, setPage] = useState(0);
  const [name, setName] = useState<any>("");
  const [phlebo, setPhlebo] = useState<any>([]);
  const [center, setCentre] = useState<any>("");
  const [file, setFile] = React.useState<any>("");
  const [rateListUploadId, setRateListUploadId] = React.useState<any>("");


  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = stopsData.links && stopsData.links.next.split("?")[1];
      getStops(url);
    } else if (newPage < page) {
      let url = stopsData.links && stopsData.links.previous.split("?")[1];
      getStops(url);
    }
    setPage(newPage as number);
  };
  const uploadRatelistSave = async (e: any) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", file);

    // await uploadRateList(formData, rateListUploadId);
    // setReset(true);
    // setLabId("");
    // setRateListUploadId("");
    // setRateListInput("");
  };
  useEffect(() => {
    // getCities();
    // getStops();
    // getBookingOverview("");
    // getDisplayCities();
    // getDisplayCities();
    getDisplayCities();

  }, []);
  const handleExport = () => {
    getDisplayCities(rateListUploadId);
  };
  //   const handleEdit = (val: any) => {
  //     setIsEdit(true);
  //     setEditId(val.id);
  //     setPlace(val?.name);
  //     setLatitude(val?.latitued);
  //     setLongitude(val?.longitude);
  //     setCity(val?.city);
  //     setCityName(val?.city_name);
  //     setCentre(val?.centre_name);
  //     setPhlebo(val?.phlebos_name);
  //   };
  //   const filterStopsData = (e: any) => {
  //     const body: any = {
  //       name,
  //       citys,
  //       panel_users: phlebo,
  //       cc: center,

  //     };
  //     const url = generateStopsFilter(body).substring(2);
  //     getStops(url);
  //     setPage(0);
  //   };
  //   const onKeyDown = (e: any) => {
  //     if (e.key === "Enter") {
  //       filterStopsData(e);
  //     }
  //   };
  const handleSearch = async (e: any) => {
    e.preventDefault();
    // getStops(`name=${stopsData}`);
  };
  const [inputList, setInputList] = useState<any>([
    {
        platforms: "",
        applications: "",
        projectTitle: "",
        samples: "",
    },
]);
  const handleInputChange = (index: any, val: any, key: any) => {
    let list = [...inputList];
    if (key === "sampleName" && val !== undefined) {
        list[index]["sampleName"] = val;
    } else if (key === "sample_ID" && val === undefined) {
        delete list[index]["sample_ID"]
    } else if (key === "samples") {
        list[index]["samples"] = val;
    } else if (key === "platforms") {
        list[index]["platforms"] = val;
    } else if (key === "applications") {
        list[index]["applications"] = val;
    }
    setInputList(list);
};

const handleRemoveClick = (index: any) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
};
const handleAddClick = () => {
    setInputList([
        ...inputList,
        {
            platforms: "",
            applications: "",
            projectTitle: "",
            samples: "",

        },
    ]);
};
  return (
    <Grid container spacing={2} style={{ marginTop: 40 }}>
      <Grid container>
        <h4>Sequencing Data</h4>
        <form onSubmit={uploadRatelistSave} style={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="Run Id"
                variant="outlined"
                className="input"
                fullWidth
                value={project}
                onChange={(e) => setProject(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="Lan Id"
                variant="outlined"
                className="input"
                fullWidth
                value={subProject}
                onChange={(e) => setSubProject(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <input
                type="file"
                onChange={(e: any) => setFile(e.target.files[0])}
                accept=".csv"
              />
              <sub>*Upload .csv (Code,SpecialPrice,SpecialMrp)</sub>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                type="submit"
                style={{ height: "55px" }}
              >
                Upload
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                color="secondary"
                variant="contained"
                fullWidth
                style={{ height: "55px" }}
                onClick={handleExport}
              // disabled={rateListUploadId === ""}
              >
                Export
              </Button>
            </Grid>
            <ExportSample rateListExport={rateListExport} loading={loading} />

          </Grid>
        </form>
        {/* <div>
          {reset && uploadRatelistData?.error !== undefined
            ? JSON.stringify(uploadRatelistData.error).replace(
              /"|{|}|[|]/g,
              ""
            )
            : ""}
        </div> */}
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  //   cities: state.LogisticsReducer.cities,
  //   stopsData: state.LogisticsReducer.stopsData,
  //   loading: state.LogisticsReducer.loading,
  //   bookingoverview: state.LogisticsReducer.bookingoverview,
  //   centerInfo: state.LogisticsReducer.centerInfo,
  //   phleboList: state.LogisticsReducer.phleboList,
  rateListExport: state.GenomicsLabReducer.rateListExport,

});
export default connect(mapStateToProps, {
  //   getStops,
  //   postStops,
  //   updateStops,
  //   getCities,
  //   getBookingOverview,
  //   getDisplayCities,

  // getDisplayCities,
})(StopsPlace);
